import React, { useEffect, useState } from "react";
import "./users.scss";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import AutoComplete from "rsuite/AutoComplete";
import Active from "../../modal/aktivasiuser/Active";
import ReactPaginate from "react-paginate";
import { CSVLink } from "react-csv";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import ReactToPrint from "react-to-print";
import { useRef } from "react";
import { AiTwotoneDownCircle } from "react-icons/ai";
import { BsSearch } from "react-icons/bs";
import dateFormat from "dateformat";
import * as XLSX from "xlsx";
import moment from "moment";


function Users() {
  const [data, setData] = useState([]);
  const [dataUserById, setDataUserById] = useState([]);

  const [autoComplete, setAutoComplete] = useState([]);
  const [search, setsearch] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const [idActive, setIdActive] = useState(false);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [getSuccess, setGetSuccess] = useState(false);
  const [staff, setStaff] = useState();
  const [itemsPerPage, setitemsPerPage] = useState(10);
  const [exp, setExp] = useState();
  const [alertAktivasi, setAlertActivasi] = useState(false);
  const idStaff = window.sessionStorage.getItem("dataLogin");
  const [idUser, setIdUser] = useState();
  let componentRef = useRef();
  const [title, setTitle] = useState();
  const [delUpdate, setDelUpDate] = useState(false);
  const [statusMember, setstatusMember] = useState('common member')
  const [discountMember, setdiscountMember] = useState()

  const getData = async () => {
    try {      
      const result = await axios.get("https://mobile.amospa.com/users");
      const name = result.data.data.map((value) => value.name);
      const phone = result.data.data.map((value) => value.phone);
      const email = result.data.data.map((value) => value.email);
      setAutoComplete(name.concat(phone, email));
      setData(result.data.data);
      setGetSuccess(true);
    } catch (error) {
      console.log('errMobile', error);
    }
  };

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  //Handle Delete
  const deleteUser = async (id) => {
    setDelUpDate("delete");
    setTitle("Delete User ?");
    setIdUser(id);
    setModalShow(true);
  };

  //Handle search
  const keys = ["name", "phone", "email"];
  const handleSearch = () => {
    return search
      ? data.filter((item) => keys.some((key) => item[key].includes(search)))
      : false;
  };

  const user = handleSearch();
  const dataTable = user ? user : currentItems;

  const getDataById = async (id) => {
    const result = await axios.get(`https://mobile.amospa.com/users/${id}`);
    return result;
  };

  const d = new Date();

  const handleActive = async () => {
    if (exp) {
      const result = await getDataById(idActive);
      const dataUpdate = result.data.data[0];
      const data = new FormData();
      data.append("name", dataUpdate.name);
      data.append("phone", dataUpdate.phone);
      data.append("email", dataUpdate.email);
      data.append("birthday", dataUpdate.birthday);
      data.append("since", d);
      data.append("expired", exp);
      data.append("active", true);
      data.append("password", dataUpdate.password);
      data.append("gender", dataUpdate.gender);
      data.append("point", dataUpdate.point);
      data.append("statusMember", statusMember);
      data.append("discount", discountMember);

      await axios.put(`https://mobile.amospa.com/users/${idActive}`, data);
      await postNote(idActive);
      await axios.post("https://mobile.amospa.com/newmember", {
        name: dataUpdate.name,
        in: d,
        out: d,
        mode: "New Member",
        notes: `${dataUpdate.name} | Exp: ${dateFormat(
          new Date(exp),
          "d-mm-yyyy"
        )} | Email: ${dataUpdate.email} | Phone: ${dataUpdate.phone}`,
      });
      setShow(false);
      window.location.reload();
    } else {
      setAlertActivasi(true);
    }
  };

  const handleNonActive = (id) => {
    setDelUpDate("non-active");
    setTitle("Non-Active User ?");
    setIdUser(id);
    setModalShow(true);
  };

  const closeModalActivasi = () => {
    setShow(false);
    setAlertActivasi(false);
  };

  const getId = (id) => {
    setShow(true);
    setIdActive(id);
  };

  //get staff by id
  const getStaffById = async () => {
    const rest = axios.create({
      baseURL: "https://mobile.amospa.com",
      headers: { Authorization: `Bearer ${idStaff}` },
    });
    const id = await rest.get("/jwt/token");
    let result = await axios.get(
      `https://mobile.amospa.com/staff/${id.data.data}`
    );
    setStaff(result.data.data[0]);
  };

  //note post
  const postNote = async (id) => {
    await axios.post(`https://mobile.amospa.com/note`, {
      userId: id,
      staffName: staff.name,
      keterangan: "New Member",
      catatan: "",
    });
  };

  //Header csv
  const headers = [
    { label: "ID", key: "id" },
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },
    { label: "Phone", key: "phone" },
    { label: "Birthday", key: "birthday" },
  ];

  //Handle Next
  const handleNext = async () => {
    if (delUpdate === "delete") {
      await axios.delete(`https://mobile.amospa.com/users/${idUser}`);
      window.location.reload();
      setModalShow(false);
    }
    if (delUpdate === "non-active") {
      const result = await getDataById(idUser);
      const dataUpdate = result.data.data[0];
      const data = new FormData();
      data.append("name", dataUpdate.name);
      data.append("phone", dataUpdate.phone);
      data.append("email", dataUpdate.email);
      data.append("birthday", dataUpdate.birthday);
      data.append("since", dataUpdate.since);
      data.append("expired", dataUpdate.expires);
      data.append("active", false);
      data.append("password", dataUpdate.password);
      data.append("gender", dataUpdate.gender);
      data.append("point", dataUpdate.point);
      data.append("statusMember", null);
      data.append("discount", null);

      await axios.put(`https://mobile.amospa.com/users/${idUser}`, data);
      await postNote(idUser);
      await axios.post(`https://mobile.amospa.com/note`, {
        userId: idUser,
        staffName: staff.name,
        // catatan: note,
        keterangan: "Stop Member",
        // lastScan: catatan.lastScan,
        // visit: catatan.visit,
      });
      setShow(false);
      window.location.reload();
    }
  };

  //XLSX
  const handleExportXlsx = () => {
    let wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(dataTable);

    XLSX.utils.book_append_sheet(wb, ws, "MySheet1");

    XLSX.writeFile(wb, "UserMobileApp.xlsx");
  };

  useEffect(() => {
    getData();
    getStaffById();
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, getSuccess]);


console.log('staftt', staff);
  return (
    <div className="wrapper-users-mobile">
      <div className="users-mobile">
        <div className="users-mobile-search py-5">
          <span className="d-flex align-items-center">
            <h3 className="text-white">User Mobile Apps</h3>
            <p className="user-mobile-show ms-2 me-1">
              <select onChange={(e) => setitemsPerPage(e.target.value)}>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>{" "}
            </p>
          </span>

          <span className="d-flex">
            <button
              onClick={handleExportXlsx}
              className="btn text-decoration me-1 fw-bold"
              style={{
                background: "#FFD700",
                color: "black",
                outline: "none",
              }}
            >
              XLSX
            </button>
            <CSVLink
              data={dataTable}
              headers={headers}
              filename="Member AMO"
              className="btn  text-decoration-none me-1 fw-bold"
              separator={";"}
              style={{ background: "#FFD700", color: "black" }}
            >
              CSV
            </CSVLink>
            <ReactToPrint
              trigger={() => {
                return (
                  <button
                    className="btn text-decoration me-1 fw-bold"
                    style={{ background: "#FFD700", color: "black" }}
                  >
                    PRINT
                  </button>
                );
              }}
              content={() => componentRef}
              documentTitle="new document"
              pageStyle="print"
              className="bg-success"
            />
            <Link to={"/homepage/users-mobile/add-user/"}>
              <button
                className="btn rounded-3 me-2 fw-bold"
                style={{ background: "#FFD700" }}
              >
                ADD USER
              </button>
            </Link>
            <span className="d-flex align-items-center list-search bg-light rounded-3 ps-1 me-2">
              <BsSearch color="black" fontSize="20px" />
              <AutoComplete
                placeholder="Search . . ."
                id="rs-input"
                onChange={(e) => setsearch(e)}
                data={autoComplete}
              />
            </span>
          </span>
        </div>
        <div className="table-users-mobile" ref={(el) => (componentRef = el)}>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>No</th>
                <th>Name</th>
                <th>Email</th>
                <th>Number Phone</th>
                <th>Birtday</th>
                <th>Status</th>
                {
                  staff?.email == 'user@amospa.com' ? null : 
                  <th>Action</th>
                }
              </tr>
            </thead>
            <tbody>
              {dataTable.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.email}</td>
                  <td>{item.phone}</td>
                  <td>{dateFormat(new Date(item.birthday), "d-mm-yyyy")}</td>
                  <td>
                    {item.active ? (
                      <span>
                        <AiTwotoneDownCircle color="green" />{" "}
                        <span>Active</span>
                      </span>
                    ) : (
                      <span>
                        <AiTwotoneDownCircle color="red" />{" "}
                        <span>Non Active</span>
                      </span>
                    )}
                  </td>
                  {
                    staff?.email == 'user@amospa.com' ? null : 
                    <td>
                      {item.active ? (
                        <button
                          className="btn-staffid m-1 bg-warning text-dark py-1"
                          style={{ width: "120px", borderRadius: "10px" }}
                          onClick={() => handleNonActive(item.id)}
                        >
                          Stop Member
                        </button>
                      ) : (
                        <button
                          className="btn-staffid m-1 bg-warning text-dark py-1"
                          style={{ width: "120px", borderRadius: "10px" }}
                          onClick={() => getId(item.id)}
                        >
                          Active Member
                        </button>
                      )}
                      <Link to={`/homepage/users-mobile/edit-user/${item.id}`}>
                        <button
                          className="btn-staffid m-1 px-3 py-1 bg-warning text-dark"
                          style={{ borderRadius: "10px" }}
                        >
                          Edit
                        </button>
                      </Link>
                      <button
                        className="btn-staffid m-1 px-2 py-1 bg-danger"
                        style={{ borderRadius: "10px" }}
                        onClick={() => deleteUser(item.id)}
                      >
                        Delete
                      </button>
                    </td>
                  }
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>

      <div className="footer-member-list my-3">
        <p className="ms-2">
          Showing {currentItems.length} to {data.length} Entries
        </p>
        <div className="footer-member-list-rigth me-1">
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            pageCount={pageCount}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            containerClassName="pagination"
            pageLinkClassName="page-num"
            previousLinkClassName="page-num"
            nextLinkClassName="page-num"
            activeLinkClassName="active"
          />
        </div>
      </div>

      <Active
        exp={(e) => setExp(e)}
        show={show}
        onHide={closeModalActivasi}
        saveButton={handleActive}
        alert={alertAktivasi}
        initValue={exp}
        setstatusMember={setstatusMember}
        setdiscountMember={setdiscountMember}
      />
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={title}
        nextButton={handleNext}
      />
    </div>
  );
}

export default Users;
